import styled from 'styled-components'
import theme from 'theme_'
import { WhiteBlock } from 'components/Layout'
import { CommonLinkButton } from 'components/Button'

export const RadioConfigFrame = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: ${theme.spacing.xs};
  max-width:80%
  margin:0 auto;
`

export const InformationFrame = styled(WhiteBlock)`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${theme.spacing.xs};
  max-width: 450px;
`

export const StyledWLANForm = styled(WhiteBlock)`
  display: flex;
  flex: 2;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  max-width: 300px;
`

export const WLANFormBlock = styled.div`
  margin: ${theme.spacing.large} 0;
  max-width: 300px;
  margin: 0 auto;
  padding-top: 5px;
`

export const WLANFormBlockText = styled.div`
  margin: ${theme.spacing.large} 0;
  max-width: 115px;
  margin: 0 auto;
  padding-top: 5px;
`

export const WLANFormInfoBlockTop = styled.div`
  margin: ${theme.spacing.base} 0;
  max-width: 550px;
  margin: 0 auto;
  padding-top: 30px;
`

export const WLANFormInfoBlock = styled.div`
  margin: ${theme.spacing.base} 0;
  max-width: 550px;
  margin: 0 auto;
  padding-top: 0px;
`

export const WLANFormBlockTitle = styled.div`
  padding-top: 15px;
  max-width: 300px;
  margin: 0 auto;
`

export const NavigateToMistButton = styled(CommonLinkButton)``

export const NavigateToMistForwardIcon = styled.img`
  width: 15;
  height: 15;
  color: ${theme.colors.black};
`
